import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard  {
  constructor(private auth: AuthenticationService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let hasToken = this.auth.getAccessToken() !== undefined && this.auth.getAccessToken() !== null && this.auth.getAccessToken() !== "";
    if (hasToken) {
      return true; 
    }
    this.auth.requestAuthCode(location.origin + state.url);
    return false;
  }
  
}
